var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-container"},[_c('SchoolHeaderModule'),_c('div',{staticClass:"admin-wrapper"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }